module.exports = __webpack_public_path__ + "static/img/gpt5.103b6ba3.jpg";